import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <------------------- Bulk Order Component -------------------->
// ###############################################################
export const Wrapper = styled.div`
  height: calc(100% - 72px);
  min-height: calc(100vh - 72px);
  padding: 16px 24px 100px;
  background-color: ${({ theme }) => theme.colors.grey001};
  box-sizing: border-box;
`;

export const PageTitle = styled(typography.H3BoldTypography)`
  margin: 0;
  color ${({ theme }) => theme.colors.grey600};
`;

export const AddPromocodeTitle = styled(typography.H4BoldTypography)`
  margin: 0;
  color ${({ theme }) => theme.colors.grey600};
`;

export const AddPromocodeInput = styled.input`
  width: 20%;
  padding: 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const AddPatientBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const AddPatientBtn = styled(typography.P2BoldTypography)`
  margin: 0;
  padding: 10px 45px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;
`;

export const ValidationErrMsg = styled(typography.P2RegularTypography)`
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};

  ${({ center }) =>
    center &&
    `
    text-align: center;
  `}
`;

export const OrderItemWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey002};
`;

export const OrderItemPatientName = styled(typography.H3BoldTypography)`
  display: flex;
  flex-grow: 1;
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const OrderItemPatientNameEditIcon = styled.span`
  margin-inline-start: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blueMain};

  &:before {
    content: 'edit';
    font-size: 12px;
  }
`;

export const OrderItemCount = styled(typography.H4RegularTypography)`
  flex: 0 0 150px;
  margin: 0;
`;

export const OrderItemAddOrderWrapper = styled.div`
  display: flex;
  padding: 20px 10px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const OrderItemSearchProductWrapper = styled.div`
  width: 500px;
`;

export const OrderItemUploadImageBtn = styled.div`
  padding: 8px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;

  &:before {
    content: '\\e90f';
    font-family: Icomoon;
    font-size: 28px;
  }
`;

export const OrderItemDeleteIcon = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  margin-inline-start: 10px;
  padding: 8px;
  color: ${({ theme }) => theme.colors.redDark};
  background-color: ${({ theme }) => theme.colors.redLight};
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;

  &:before {
    content: '\\e9ad';
    font-family: Icomoon;
    font-size: 14px;
  }
`;

export const BottomBarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  width: calc(100% - 88px);
  height: 62px;
  padding: 10px 100px;
  background-color: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;

  & > * + * {
    margin-inline-start: 10px !important;
  }
`;

export const OrderSubmitBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 160px;
  height: 42px;
`;

export const OrderSubmitBtn = styled(typography.P2BoldTypography)`
  width: 100%;
  margin: 0;
  padding: 10px 30px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;
`;

export const OrderBackBtn = styled(OrderSubmitBtn)`
  width: unset;
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
`;

export const OrderTotalPrice = styled(typography.H4BoldTypography)`
  margin: 0;
  margin-inline-start: auto !important;
`;

export const SubmissionResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SubmissionResultIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${({ circleColor }) => circleColor};
`;

export const SubmissionResultIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ backgroundColor }) => backgroundColor};

  &:before {
    content: ${({ icon }) => icon};
    font-family: Icomoon;
    font-size: 24px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const SubmissionResultText = styled(typography.H3BoldTypography)`
  margin: 0;
`;
// ###############################################################
// <----------------- End Bulk Order Component ------------------>
// ###############################################################

// ###############################################################
// <----------------- Choose Address Component ------------------>
// ###############################################################
export const AddressWrapper = styled.div`
  padding: 0 60px;
`;

export const AddressGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  grid-gap: 40px;
`;

export const AddressCard = styled.div`
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;

  &: hover {
    border: 1px solid ${({ theme }) => theme.colors.greenMain};
  }

  ${({ selected, theme }) =>
    selected &&
    `
    border: 1px solid ${theme.colors.greenMain};
  `}
`;

export const AddressType = styled(typography.P1BoldTypography)`
  margin: 0;
`;

export const AddressDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AddressDetailsTitle = styled(typography.P2RegularTypography)`
  margin: 0;
`;

export const AddressDetailsValue = styled(typography.P2BoldTypography)`
  margin: 0;
`;

export const AddAddressbtn = styled(typography.P2BoldTypography)`
  margin: 0;
  padding: 10px 30px;
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <--------------- End Choose Address Component ---------------->
// ###############################################################

// ###############################################################
// <----------------- Search Products Envelop ------------------->
// ###############################################################
export const EnvelopItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey003};
    cursor: pointer;
  }

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const EnvelopItemImage = styled.img`
  width: 60px;
`;

export const EnvelopItemNameWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  & > * + * {
    margin-top: 6px !important;
  }
`;

export const EnvelopItemName = styled(typography.P1BoldTypography)`
  margin: 0;
`;

export const EnvelopItemType = styled(typography.P2RegularTypography)`
  margin: 0;
`;

export const EnvelopItemPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 85px;

  & > * + * {
    margin-top: 2px !important;
  }
`;

export const EnvelopItemPrice = styled(typography.P2RegularTypography)`
  margin: 0;
`;

export const EnvelopItemStock = styled(typography.P2RegularTypography)`
  margin: 0;
  padding: 4px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;

  ${({ fullHeight }) =>
    fullHeight &&
    `
    min-height: calc(100vh - 52px);`}
`;

export const NoDataText = styled.p`
  margin: 0;
  font-size: 15px;
  color: #9c9c9c;
`;
// ###############################################################
// <--------------- End Search Products Envelop ----------------->
// ###############################################################

// ###############################################################
// <---------------------- Order Details ------------------------>
// ###############################################################
export const OrderDetailsItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey004};

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const OrderDetailsItemImage = styled.img`
  width: 60px;
`;

export const OrderDetailsItemNameWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  & > * + * {
    margin-top: 6px !important;
  }
`;

export const OrderDetailsItemName = styled(typography.P1BoldTypography)`
  margin: 0;
`;

export const OrderDetailsItemType = styled(typography.P2RegularTypography)`
  margin: 0;
`;

export const OrderDetailsItemPrice = styled(typography.P2RegularTypography)`
  flex: 0 0 85px;
  margin: 0;
`;

export const OrderDetailsItemActionWrapper = styled.div`
  display: flex;
  flex: 0 0 96px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.grey500};
  border-radius: 4px;
`;

export const OrderDetailsItemActionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: Icomoon;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.blueMain};
  }
`;

export const OrderDetailsItemActionQuantity = styled(typography.H3BoldTypography)`
  flex: 1;
  margin: 0;
  padding: 3px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey500};
  background-color: ${({ theme }) => theme.colors.blueLight};
`;
// ###############################################################
// <-------------------- End Order Details ---------------------->
// ###############################################################

// ###############################################################
// <------------------------ Order File ------------------------->
// ###############################################################
export const FileItemWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey004};
`;

export const FileItemPadding = styled.div`
  padding-top: 100%;
`;

export const FileImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  ${({ opacity }) =>
    opacity &&
    `
    opacity: ${opacity};
  `}
  ${({ blur }) =>
    blur &&
    `
    filter: blur(${blur}px);
  `}
`;

export const ResizedFileImg = styled.img.attrs(({ dimenParamToChange, ratio }) => {
  const width = dimenParamToChange === 'width' ? `calc(100% * ${ratio})` : '100%';
  const height = dimenParamToChange === 'height' ? `calc(100% * ${ratio})` : '100%';

  return {
    style: {
      width,
      height,
    },
  };
})`
  position: absolute;
  top: 0;
`;

export const ImgDeleteOverlay = styled.div`
  position: absolute;
  top: 0;
  display: none;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.grey500};
  opacity: 0.6;
  cursor: pointer;
`;

export const ImgDeleteIcon = styled.span`
  display: none;
  cursor: pointer;
  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    position: absolute;
    top: 7px;
    right: 7px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const FileItem = styled.div`
  position: relative;
  width: 200px;
  height: 200px;

  &:hover {
    ${ImgDeleteOverlay} {
      display: block;
    }
    ${ImgDeleteIcon} {
      display: block;
    }
  }
`;

export const ImgPreview = styled.img``;
// ###############################################################
// <---------------------- End Order File ----------------------->
// ###############################################################

// ###############################################################
// <--------------------- Add Patient Popup --------------------->
// ###############################################################
export const AddPatientPopUpWrapper = styled.div`
  width: 600px;
  padding: 16px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const AddPatientPopUpTitleWrapper = styled.div`
  padding: 0 24px;
`;

export const AddPatientPopUpTitle = styled(typography.H4RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const AddPatientPopUpFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px;
`;

export const AddPatientPopUpLabel = styled(typography.P1BoldTypography)`
  width: 100%;
  margin: 0;
`;

export const AddPatientPopUpInput = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const AddPatientPopUpBtn = styled(typography.P2BoldTypography)`
  width: fit-content;
  margin: 0;
  padding: 10px 45px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <------------------- End Add Patient Popup ------------------->
// ###############################################################
